import React from 'react'
import styles from './Skeleton.module.scss'

const Skeleton = ({ width, height }) => {
  const style = {
    width,
    height
  }
  return <span className={styles.skeleton} style={style}></span>
}

export default Skeleton
